/**
 * Registers FCM push token with the backend when user is logged in.
 * Runs on app load for already-logged-in users (e.g. from localStorage restore).
 */
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { UPDATE } from "../components/constants/request-type";
import { service_api } from "../components/constants/url";
import { MakeRequestAsync } from "../components/functions/axios";
import { getFCMToken } from "../utils/firebaseMessaging";
import { createLogger } from "../utils/logger";

const logger = createLogger("PushTokenRegistration");

export const usePushTokenRegistration = () => {
  const userData = useSelector((state) => state.user);
  const lastRegisteredTokenRef = useRef(null);

  useEffect(() => {
    const userId = userData?._id;
    const token = userData?.refresh_token;

    if (!userId || !token) return;

    const registerToken = async () => {
      const pushToken = await getFCMToken();
      if (!pushToken) return;

      // Avoid re-registering the same token
      if (lastRegisteredTokenRef.current === pushToken) return;
      lastRegisteredTokenRef.current = pushToken;

      try {
        await MakeRequestAsync({
          type: UPDATE,
          url: service_api,
          route: `user/update-user/${userId}`,
          data: { pushToken },
          token
        });
        logger.log("Push token registered successfully");
      } catch (err) {
        logger.warn("Failed to register push token:", err?.response?.data?.message);
        lastRegisteredTokenRef.current = null;
      }
    };

    registerToken();
  }, [userData?._id, userData?.refresh_token]);
};
